module.exports = __webpack_public_path__ + "assets/img/user_achievement_l3.419053b7.png";